import { Link } from "react-router-dom";
import nextDouble from "../assets/images/icons/next-double.svg";
import { useTranslation } from "../components/Localization";
import RoomPage from "../components/RoomPage";

export default function ExtraPage() {
  const { t } = useTranslation();
  return <RoomPage
    roomId="extra"
    slug="extra"
    className="extra-page"
    navigation={<Link className="extra-next" to="/befejezes" aria-label={t("common.next")}><img src={nextDouble} alt="" /></Link>}
  />;
}
